import { Modal, Button } from "react-bootstrap";

interface ReactivatePlanModalProps {
  show: boolean;
  onHide: () => void;
  onActivateNow: () => void;
  onActivateNextCycle: () => void;
}

export default function ReactivatePlanModal({
  show,
  onHide,
  onActivateNow,
  onActivateNextCycle,
}: ReactivatePlanModalProps) {
  return (
    <Modal centered show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>Activate Plan</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          Would you like to activate your plan <strong>immediately</strong> or
          wait until the
          <strong> next billing cycle</strong>? Prorated charges may apply if
          activated now.
        </p>
        <div className="d-flex flex-column gap-3 mt-3">
          <Button variant="primary" onClick={onActivateNow}>
            Start Immediately
          </Button>
          <Button variant="primary" onClick={onActivateNextCycle}>
            Start at Next Billing Cycle
          </Button>
          <Button variant="outline-secondary" onClick={onHide}>
            Go Back
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
}
